// extracted by mini-css-extract-plugin
export var button = "status-bar-module--button--ea69c";
export var content = "status-bar-module--content--7367c";
export var error = "status-bar-module--error--8737c";
export var holder = "status-bar-module--holder--d37c2";
export var success = "status-bar-module--success--aa456";
export var warning = "status-bar-module--warning--aa49b";